import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Popup } from 'azure-maps-control';

const AzureMapPopup = ({ map, marker, children, options = {} }) => {
    const popupRef = useRef(null);
    const containerRef = useRef(document.createElement('div'));

    useEffect(() => {
        if (!map || !marker) return;

        // Create the Popup
        const popup = new Popup({
            content: containerRef.current,
            pixelOffset: [0, -30],
            ...options
        });

        popupRef.current = popup;
        map.popups.add(popup);

        const togglePopup = () => {
            if (popup.isOpen()) {
                popup.close();
            } else {
                // Ensure popup is positioned at the marker
                popup.setOptions({
                    position: marker.getOptions().position
                });
                popup.open(map);
            }
        };

        // Attach click event to marker to open popup
        map.events.add('click', marker, togglePopup);

        return () => {
            map.events.remove('click', marker, togglePopup);
            if (popupRef.current) {
                map.popups.remove(popupRef.current);
            }
        };
    }, [map, marker, JSON.stringify(options)]);

    return ReactDOM.createPortal(children, containerRef.current);
};

export default AzureMapPopup;
